import { ClientModel } from '@/modules/client/client-model';

const { fields } = ClientModel;

export default [
  fields.id,

  fields.createdAt
];
